<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<router-outlet></router-outlet>
